(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('timed-promo-bar')) {
    customElements.define(
      'timed-promo-bar',
      class extends HTMLElement {
        connectedCallback() {
          if (this.stopSchedule) {
            this.stopSchedule();
          }

          const root = this.closest('.shopify-section') || this;
          const controller = new AbortController();

          const interval = Math.max(
            3,
            Number(this.dataset.interval) || 5
          ) * 1000;

          const messages = Array.from(
            this.querySelectorAll('.promo-timed-item')
          ).map((node) => {
            const start = this.parseDate(node.dataset.start);
            const end = this.parseDate(node.dataset.end);

            const invalid =
              Number.isNaN(start) ||
              Number.isNaN(end) ||
              (
                start !== null &&
                end !== null &&
                end <= start
              );

            if (invalid) {
              console.warn(
                '[告知バー] 日時設定が不正です。',
                node.dataset.blockId,
                'YYYY-MM-DD HH:mm形式で、終了を開始より後に設定してください。'
              );
            }

            return { node, start, end, invalid };
          });

          let timer = null;
          let active = [];
          let current = null;
          let lastKey = null;
          let nextRotation = Date.now() + interval;
          let stopped = false;
          let hovered = false;

          const paused = () => {
            return (
              document.hidden ||
              hovered ||
              this.contains(document.activeElement)
            );
          };

          const draw = () => {
            messages.forEach((message) => {
              const shown = message === current;

              message.node.hidden = !shown;
              message.node.inert = !shown;
              message.node.setAttribute(
                'aria-hidden',
                String(!shown)
              );
            });

            root.toggleAttribute(
              'data-promo-empty',
              active.length === 0
            );

            this.setAttribute('data-ready', '');
          };

          const refresh = () => {
            clearTimeout(timer);

            if (stopped || !this.isConnected) return;

            const now = Date.now();

            const nextActive = messages.filter((message) => {
              return (
                !message.invalid &&
                (
                  message.start === null ||
                  now >= message.start
                ) &&
                (
                  message.end === null ||
                  now < message.end
                )
              );
            });

            const nextKey = nextActive.map((message) => {
              return message.node.dataset.blockId;
            }).join('|');

            let changed = nextKey !== lastKey;

            if (changed) {
              active = nextActive;
              lastKey = nextKey;

              if (!active.includes(current)) {
                current = active[0] || null;
              }

              nextRotation = now + interval;
            }

            // 操作中は告知の自動巡回を止める。
            // 表示開始・終了の判定は継続する。
            if (paused()) {
              nextRotation = now + interval;
            }

            if (
              active.length > 1 &&
              !paused() &&
              now >= nextRotation
            ) {
              const nextIndex =
                (active.indexOf(current) + 1) % active.length;

              current = active[nextIndex];
              nextRotation = now + interval;
              changed = true;
            }

            if (changed) {
              draw();
            }

            // 最大1秒ごとに確認し、直近の境界時刻には
            // その時刻に合わせて再判定する。
            let delay = 1000;

            messages.forEach((message) => {
              if (message.invalid) return;

              [message.start, message.end].forEach((boundary) => {
                if (boundary !== null && boundary > now) {
                  delay = Math.min(delay, boundary - now);
                }
              });
            });

            if (active.length > 1 && !paused()) {
              delay = Math.min(
                delay,
                nextRotation - now
              );
            }

            timer = setTimeout(
              refresh,
              Math.max(1, delay)
            );
          };

          const listen = (target, type, handler) => {
            target.addEventListener(type, handler, {
              signal: controller.signal
            });
          };

          listen(this, 'mouseenter', () => {
            hovered = true;
            refresh();
          });

          listen(this, 'mouseleave', () => {
            hovered = false;
            nextRotation = Date.now() + interval;
            refresh();
          });

          listen(this, 'focusin', refresh);

          listen(this, 'focusout', () => {
            nextRotation = Date.now() + interval;
          });

          listen(document, 'visibilitychange', () => {
            nextRotation = Date.now() + interval;
            refresh();
          });

          listen(window, 'focus', refresh);
          listen(window, 'pageshow', refresh);

          // テーマ編集画面で、表示期間内の告知を選択したら表示。
          listen(document, 'shopify:block:select', (event) => {
            if (!this.contains(event.target)) return;

            refresh();

            const selected = active.find((message) => {
              return (
                message.node.dataset.blockId ===
                event.detail?.blockId
              );
            });

            if (selected) {
              current = selected;
              nextRotation = Date.now() + interval;
              draw();
            }
          });

          this.stopSchedule = () => {
            stopped = true;
            clearTimeout(timer);
            controller.abort();
          };

          refresh();
        }

        disconnectedCallback() {
          if (this.stopSchedule) {
            this.stopSchedule();
            this.stopSchedule = null;
          }
        }

        // 日本時間の YYYY-MM-DD HH:mm を数値に変換する。
        parseDate(value) {
          const text = String(value || '').trim();

          if (!text) return null;

          const match = text.match(
            /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/
          );

          if (!match) return NaN;

          const [year, month, day, hour, minute] =
            match.slice(1).map(Number);

          if (
            year < 1000 ||
            month < 1 || month > 12 ||
            day < 1 || day > 31 ||
            hour > 23 ||
            minute > 59
          ) {
            return NaN;
          }

          const utc = Date.UTC(
            year,
            month - 1,
            day,
            hour,
            minute
          );

          const date = new Date(utc);

          // 2月30日など、存在しない日付を除外する。
          if (
            date.getUTCFullYear() !== year ||
            date.getUTCMonth() !== month - 1 ||
            date.getUTCDate() !== day
          ) {
            return NaN;
          }

          return utc - 9 * 60 * 60 * 1000;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
